import { UTCDate, utc } from '@date-fns/utc';
import { format, isValid, parseISO } from 'date-fns';
import { CalendarDateRange, DateRange } from './types';

/** Reject timestamps and invalid dates instead of guessing a timezone or rolling a day over. */
export function parseCalendarDate(value: string): UTCDate | null {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return null;
    }
    const date = parseISO(value, { in: utc });
    return isValid(date) && formatCalendarDate(date) === value ? date : null;
}

export function formatCalendarDate(date: UTCDate): string {
    return format(date, 'yyyy-MM-dd');
}

export function parseCalendarRange(range: DateRange): CalendarDateRange | null {
    const start = parseCalendarDate(range.start);
    const end = parseCalendarDate(range.end);
    if (!start || !end) {
        return null;
    }
    return start <= end
        ? { ...range, start, end }
        : { ...range, start: end, end: start };
}

export function formatCalendarRange(range: CalendarDateRange): DateRange {
    return {
        ...range,
        start: formatCalendarDate(range.start),
        end: formatCalendarDate(range.end),
    };
}
